import { useMemo } from 'react';

import { Add, DeleteOutlineOutlined } from '@mui/icons-material';
import { Box, Button, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import { getIn, useFormikContext } from 'formik';

import { CissNumberField, CissTextField } from 'components/fields';
import { DreFormGroup } from 'pages/financeiro/dre/components/templates/DreFormGroup';
import { DreFormRow } from 'pages/financeiro/dre/components/templates/DreFormRow';
import { useRecalculateDre } from 'pages/financeiro/dre/hooks';
import { DreForm } from 'pages/financeiro/dre/types';

export function DreFormDespesasExtras() {
    const { errors, values, setFieldValue } = useFormikContext<DreForm>();
    const { recalculateValidatedDre } = useRecalculateDre();

    return useMemo(
        () => (
            <DreFormGroup label="Despesas extras" id="4">
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    {values.dreMercadologicaDespesasVariaveis?.map((despesa, index) => {
                        const isLast = index === values.dreMercadologicaDespesasVariaveis.length - 1;
                        const preffix = `dreMercadologicaDespesasVariaveis[${index}]`;

                        return (
                            <DreFormRow
                                key={index}
                                sx={{
                                    borderColor: 'grey.300',
                                    borderBottomStyle: 'solid',
                                    paddingBottom: isLast ? 0 : 1.5,
                                    borderBottomWidth: isLast ? 0 : 1,
                                }}
                            >
                                <CissTextField
                                    label="Nome da despesa"
                                    value={despesa.dsDespesa}
                                    name={`${preffix}.dsDespesa`}
                                    error={getIn(errors, `${preffix}.dsDespesa`)}
                                    onChange={(e) => setFieldValue(`${preffix}.dsDespesa`, e.target.value)}
                                />

                                <CissNumberField
                                    allowNegative
                                    label="Valor (R$)"
                                    inputType="decimal"
                                    value={despesa.vlTotal}
                                    name={`${preffix}.vlTotal`}
                                    onBlur={recalculateValidatedDre}
                                    error={getIn(errors, `${preffix}.vlTotal`)}
                                    onChange={(e) => setFieldValue(`${preffix}.vlTotal`, Number(e.target.value))}
                                />

                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                    <FormControlLabel
                                        label="Recorrente"
                                        sx={{ m: 0, flex: 1 }}
                                        control={<Checkbox />}
                                        checked={despesa.fgRecorrente}
                                        name={`${preffix}.fgRecorrente`}
                                        onChange={(e, checked) => setFieldValue(`${preffix}.fgRecorrente`, checked)}
                                    />

                                    <IconButton
                                        onClick={() => {
                                            const updatedDespesas = values.dreMercadologicaDespesasVariaveis.filter((_, i) => i !== index);
                                            setFieldValue('dreMercadologicaDespesasVariaveis', updatedDespesas);
                                        }}
                                    >
                                        <DeleteOutlineOutlined color="error" />
                                    </IconButton>
                                </Box>
                            </DreFormRow>
                        );
                    })}

                    <Button
                        startIcon={<Add />}
                        sx={{ alignSelf: 'flex-start', lineHeight: 1 }}
                        onClick={() => {
                            const newIndex = (values.dreMercadologicaDespesasVariaveis.length + 1) * -1;
                            const newDespesa = {
                                idDreMercadologicaDespesaVariavel: newIndex,
                                dsDespesa: '',
                                vlTotal: 0,
                                fgRecorrente: false,
                            };

                            setFieldValue('dreMercadologicaDespesasVariaveis', [...values.dreMercadologicaDespesasVariaveis, newDespesa]);
                        }}
                    >
                        Adicionar despesa extra
                    </Button>
                </Box>
            </DreFormGroup>
        ),
        [values.dreMercadologicaDespesasVariaveis, errors.dreMercadologicaDespesasVariaveis],
    );
}
